export default "__VITE_ASSET__BLN6QqS6__"